import {
  handleNameChange,
  handleNameBlur,
  handleSurnameChange,
  handleSurnameBlur,
  handleNationalIdChange,
  handleNationalIdBlur,
  handleEmailChange,
  handleEmailBlur,
  handlePhoneChange,
  handlePhoneBlur,
  getErrorCodiceFiscale,
  getErrorEmail,
  formatCouponDate,
  getGenderFromCf,
  maskEmail
} from "./EasySignupHandlers";
import React, { useEffect } from "react";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-blue/theme.css"; // o il tema che usi
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { useRef } from "react";
import "./EasySignup.component.css";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { InputText } from "primereact/inputtext";
import {
  MAXLENGTH_EMAIL,
  MAXLENGTH_NAME,
  MAXLENGTH_NATIONAL_ID_NUMBER,
  MAXLENGTH_PHONE,
  MAXLENGTH_SURNAME,
} from "../../static/constants";
import { Button } from "primereact/button";
import {
  registerAppAccount,
  registerUserAndCustomer,
  // registerUser,
} from "../../service/easySignup.service";
import { selfRegisterUser } from "../../service/easySignup.service";
import { RegisterUserAndCustomerRequestModel, SelfRegisterRequestModel, SelfRegisterSecurityBehaviourEnum, WelcomeCouponData } from "../../static/easySignup.model";
import { Dialog } from "primereact/dialog";
import { InputSwitch } from "primereact/inputswitch";
import CodiceFiscaleCalculator from "../CodiceFiscaleCalculator/codiceFiscaleCalculator";
import {
  Viewer,
  Worker,
  SpecialZoomLevel,
  ViewMode,
  LoadError,
} from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { renderErrorViewerPdf } from "../../utilities/pdf-viewer.utilities";
import LoadingSpinner from "../loading-spinner/loading-spinner"; // se non ce l’hai, crea un semplice spinner
// import { easySignupModel } from "../../static/easySignup.model";
import {
  checkValidationRequiredString,
  clearLocalStorage,
  Enum_ValidationString,
  goTo,
} from "../../utilities/common.utilities";
import { getPharmaListNationalIdNumber } from "../../service/pharmaList.service";
import { getUser } from "../../service/login.service";
import DOMPurify from "dompurify";
import JsBarcode from 'jsbarcode';

type InputInfoStatus = {
  value: string;
  valid: boolean;
  showError: boolean;
};

export default function EasySignupComponent() {

  const [generatedCoupon, setGeneratedCoupon] = useState<WelcomeCouponData | null>(null);
  const [showCouponDialog, setShowCouponDialog] = useState(false);
  const [generatedCard, setGeneratedCard] = useState<string>("");
  const [cardPrefix, setCardPrefix] = useState<string>('');
  const [selfRegisterRequest, setSelfRegisterRequest] = useState<SelfRegisterRequestModel | null>(null);
  const [securityBehaviour, setSecurityBehaviour] = useState<SelfRegisterSecurityBehaviourEnum>(SelfRegisterSecurityBehaviourEnum.MaxSecurity);
  const [isMailSent, setIsMailSent] = useState<boolean>(false);
  const [sentToEmail, setSentToEmail] = useState<string>('');
  const [showMainScreen, setShowMainScreen] = useState(true);
  const [showFinalSuccessPage, setShowFinalSuccessPage] = useState(false);
  const [showExistingAppUserPage, setShowExistingAppUserPage] = useState(false);
  const [isPrivacy1Expanded, setIsPrivacy1Expanded] = useState<boolean>(false);
  const [isPrivacy2Expanded, setIsPrivacy2Expanded] = useState<boolean>(false);
  const [isPrivacy3Expanded, setIsPrivacy3Expanded] = useState<boolean>(false);
  const [reopenConfirmOnClose, setReopenConfirmOnClose] = useState(true);
  const [showExistingCustomerPage, setShowExistingCustomerPage] = useState(false);
  const [canSendCardEmail, setCanSendCardEmail] = useState(false);
  const [showEmailSentMessage, setShowEmailSentMessage] = useState(false);
  const [cfCalcData, setCfCalcData] = useState<{
      sesso: "M" | "F";
      comune: string;
      provincia: string;
      dataNascita: Date | null;
    }>({
      sesso: "M",
      comune: "",
      provincia: "",
      dataNascita: null,
    });

  const textToBase64Barcode = (text: string) => {
      const canvas = document.createElement("canvas");
      JsBarcode(canvas, text, {
          format: "CODE128",
          width: 3,
          background: "white",
          displayValue: false,
      });
      return canvas.toDataURL("image/png");
  };



  const handleSignup = async () => {
    if (
      !name.valid ||
      !surname.valid ||
      !email.valid ||
      !phone.valid ||
      !nationalIdNumber.valid
    ) {
      onSignupShowError();
      return;
    }

    setLoadingRegister(true);


    const request: SelfRegisterRequestModel = {
      FirstName: name.value,
      LastName: surname.value,
      Gender: getGenderFromCf(nationalIdNumber.value),
      Email: email.value,

      NationalIdNumber: nationalIdNumber.value,
      StoreCode: storeData.storeCode,
      MobilePhone: phone.value,

      GroupId: storeData.groupId,

      OverrideIdCreatorPlatformType: null,

      // Mappa i consensi sui flag Privacy1/2/3
      Privacy1: consentProfilazione,
      Privacy2: consentMarketing,
      // Privacy3: storeData.privacy3Enabled && privacy3 ? true : null,
      Privacy3: storeData.privacy3Enabled.value === true ? privacy3 : null,
      PrivacyPrintedOnDate: new Date().toISOString(),

      // Usa il parametro "source" della URL come origine registrazione
      UrlRegistrationSource: source || `easy-signup`,
      FullUrlRegistrationSource: window.location.href
    };

    setSelfRegisterRequest(request);          // <<— la salvi

    const result = await selfRegisterUser(request);

    const showToast = (
      severity: "success" | "error" | "warn",
      summary: string,
      detail: string,
      life?: number
    ) => {
      toast.current?.show({ severity, summary, detail, life: 3000 });
    };

    switch (result.type) {

        case "success": {
          setGeneratedCoupon(result.welcomeCouponData ?? null);
          setGeneratedCard(result.customer?.card ?? "");
          setRegistrationSuccess(true);
          setShowMainScreen(false);
          setShowFinalSuccessPage(true);
          break;
        }


        // case "existsSameStore": {
        //   setGeneratedCoupon(null);
        //   setGeneratedCard(result.customer?.card ?? "");
        //   const hasAppUser = !!result.username;

        //   showToast("warn", "Utente già esistente", result.message, 5000);
        //   setRegistrationSuccess(true);
        //   setShowMainScreen(false);

        //   if (hasAppUser) {
        //     setShowExistingAppUserPage(true);
        //   } else {
        //     setShowExistingCustomerPage(true);
        //   }
        //   break;
        // }


        // case "existsOtherStore": {
        //   setGeneratedCoupon(null);
        //   setGeneratedCard(result.customer?.card ?? "");
        //   const hasAppUser = !!result.username;

        //   showToast("warn", "Cliente in altro store", result.message, 5000);
        //   setRegistrationSuccess(true);
        //   setShowMainScreen(false);

        //   if (hasAppUser) {
        //     setShowExistingAppUserPage(true);
        //   } else {
        //     setShowExistingCustomerPage(true);
        //   }
        //   break;
        // }
        case 'existsSameStore':
        case 'existsOtherStore': {
          setGeneratedCoupon(null);
          setGeneratedCard(result.customer?.card ?? "");

          // RECUPERA IL LIVELLO DALLO STORE DATA CARICATO ALL'AVVIO DELLA PAGINA
          const comportamentoStore = storeData?.selfRegisterSecurityBehaviour ?? SelfRegisterSecurityBehaviourEnum.MaxSecurity;
          setSecurityBehaviour(comportamentoStore);

          // RECUPERA L'EMAIL DAL CUSTOMER RESTITUITO DAL BACKEND
          const userEmail = result.customer?.email ?? "";
          setSentToEmail(userEmail);

          // Salva se la mail è stata inviata davvero
          setIsMailSent((result as any).mailSent ?? false)

          const hasAppUser = !!result.username;

          showToast("warn", "Utente già esistente", result.message, 5000);
          setRegistrationSuccess(true);
          setShowMainScreen(false);

          const existingEmail = result.customer?.email ?? null;
          const hasEmail = !!existingEmail?.trim();

          setShowEmailSentMessage(hasEmail);
          setGeneratedCard(hasEmail ? (result.customer?.card ?? '') : '');

          showToast(
            'warn',
            result.type === 'existsSameStore' ? 'Utente già esistente' : 'Cliente in altro store',
            result.message,
            5000
          );

          setRegistrationSuccess(true);
          setShowMainScreen(false);

          if (hasAppUser) setShowExistingAppUserPage(true);
          else setShowExistingCustomerPage(true);

          break;
        }

        
      case "error":
        default:
          setGeneratedCoupon(null);
          setGeneratedCard("");
          setShowCouponDialog(false);
          // Usa status + messaggio del backend
          const summary =
            result.status === 400 || result.status === 402
              ? "Dati non validi"
              : result.status === 403
              ? "Store non abilitato"
              : result.status === 404
              ? "Store non trovato"
              : result.status === 409
              ? "Conflitto dati"
              : "Errore di registrazione";
  
          showToast("error", summary, result.message, 5000);
          break;
      }

    setLoadingRegister(false);
  };

  const defaultInfoStatus: InputInfoStatus = {
    value: "",
    valid: false,
    showError: false,
  };

  const toast = useRef<Toast>(null);
  const { storeCodeEncrypted, source } = useParams<{ storeCodeEncrypted: string, source: string }>();
  const [loadingRegister, setLoadingRegister] = useState(false);
  const [storeData, setStoreData] = useState<any>(null);
  const [selfRegistrationAllowed, setSelfRegistrationAllowed] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState(false);
  const [showConsentDialog, setShowConsentDialog] = useState(false);
  const [showCfDialog, setShowCfDialog] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [showAppSuccessDialog, setShowAppSuccessDialog] = useState(false);

  const [showAppSignupDialog, setShowAppSignupDialog] = useState(false);
  const [usernameApp, setUsernameApp] = useState("");
  const [usernameAppError, setUsernameAppError] = useState('');
  const [passwordApp, setPasswordApp] = useState("");
  const [showPasswordApp, setShowPasswordApp] = useState(false);
  const [showUsernameError, setShowUsernameError] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState(false);
  const isUsernameValid = checkValidationRequiredString(
    usernameApp,
    Enum_ValidationString.Username
  );
  const isPasswordValid = checkValidationRequiredString(
    passwordApp,
    Enum_ValidationString.Password
  );
  const [showAppSignupConfirmDialog, setShowAppSignupConfirmDialog] =
    useState(false);

    const [showSuccessPage, setShowSuccessPage] = useState(false);

  const [consentProfilazione, setConsentProfilazione] = useState(false);
  const [consentMarketing, setConsentMarketing] = useState(false);
  const [privacy3, setPrivacy3] = useState(false);
  const [couponEnabled, setCouponEnabled] = useState(false);
  const [couponMessageText, setCouponMessageText] = useState("");
  const [couponMessageHtml, setCouponMessageHtml] = useState("");
  const [registrationUrlDisabled, setRegistrationUrlDisabled] = useState(false);
  const [registrationUrlDeleted, setRegistrationUrlDeleted] = useState(false);
  const [registrationUrlDisabledBySource, setRegistrationUrlDisabledBySource] = useState(false);


  const [showPrivacyDialog, setShowPrivacyDialog] = useState(false);
  const [renderKeyWorker, setRenderKeyWorker] = useState(0);
  const errorViewerFilePdf = useRef(false);

  const [name, setName] = useState<InputInfoStatus>(defaultInfoStatus);
  const [surname, setSurname] = useState<InputInfoStatus>(defaultInfoStatus);
  const [checkCharsNameSurname, setCheckCharsNameSurname] =
    useState<boolean>(true);
  const [nationalIdNumber, setNationalIdNumber] =
    useState<InputInfoStatus>(defaultInfoStatus);
  const [phone, setPhone] = useState<InputInfoStatus>(defaultInfoStatus);
  const [email, setEmail] = useState<InputInfoStatus>(defaultInfoStatus);

  const passwordChecks = [
    { label: "Almeno 8 caratteri", valid: passwordApp.length >= 8 },
    { label: "Una lettera Maiuscola", valid: /[A-Z]/.test(passwordApp) },
    { label: "Una lettera minuscola", valid: /[a-z]/.test(passwordApp) },
    { label: "Un numero", valid: /[0-9]/.test(passwordApp) },
  ];

  const fullCardCode = `${cardPrefix}${generatedCard || ''}`;

  const isPasswordValidDetailed = passwordChecks.every(x => x.valid);

  const resetFullRegistrationFlow = () => {
    setSelfRegisterRequest(null);
    setGeneratedCoupon(null);
    setGeneratedCard("");
    setCardPrefix('');
    setShowCouponDialog(false);

    setName(defaultInfoStatus);
    setSurname(defaultInfoStatus);
    setNationalIdNumber(defaultInfoStatus);
    setPhone(defaultInfoStatus);
    setEmail(defaultInfoStatus);

    setCheckCharsNameSurname(true);

    setConsentProfilazione(false);
    setConsentMarketing(false);
    setPrivacy3(false);

    setRegistrationSuccess(false);
    setShowMainScreen(true);
    setShowFinalSuccessPage(false);
    setShowExistingAppUserPage(false);
    setShowExistingCustomerPage(false);
    setShowAppSignupConfirmDialog(false);
    setShowAppSignupDialog(false);
    setShowAppSuccessDialog(false);

    setUsernameApp("");
    setPasswordApp("");
    setShowUsernameError(false);
    setShowPasswordError(false);
    setLoadingRegister(false);

    setShowConsentDialog(false);
    setShowCfDialog(false);
    setShowPrivacyDialog(false);

    setRegistrationUrlDisabled(false);
    setRegistrationUrlDeleted(false);
    setRegistrationUrlDisabledBySource(false)
    setSecurityBehaviour(SelfRegisterSecurityBehaviourEnum.MaxSecurity);
    setIsMailSent(false);
    setSentToEmail('');
  };

  useEffect(() => {
    resetFullRegistrationFlow();
  }, [storeCodeEncrypted, source]);

  useEffect(() => {

    if (!storeCodeEncrypted) return;

    const params = new URLSearchParams({
      storeCodeCrypted: storeCodeEncrypted ?? "",
      source: source ?? "",
      sourceTypeId: "1", // esempio: easySignup
    });

    const apiUrl = `${process.env.REACT_APP_API_URL}/v3/stores/getstoreinfo?${params.toString()}`;
    const isHex = (s?: string): s is string => typeof s === "string" && /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(s);
    const setToggleSecondaryColor = (color: string | undefined) => {
      if (isHex(color)) {
          // Hex → RGB per rgba()
          const r = parseInt(color.slice(1, 3), 16);
          const g = parseInt(color.slice(3, 5), 16);
          const b = parseInt(color.slice(5, 7), 16);
          document.documentElement.style.setProperty("--color-secondary-rgb", `${r}, ${g}, ${b}`);
        }
    };

    setLoading(true);
    setErrore(false);

    fetch(apiUrl)
      .then((res) => {
        if (!res.ok) throw new Error("Errore nella risposta");
        return res.json();
      })
      .then((data) => {
        setStoreData(data);
        setCardPrefix(data?.cardPrefix ?? '');

        // tema EasySignup -> CSS variables
        const theme = data.easySignupTheme || {};
        if (isHex(theme.easySignupPrimaryColor)) {
          document.documentElement.style.setProperty("--color-header", theme.easySignupPrimaryColor);
        }
        if (isHex(theme.easySignupPrincipalColor)) {
          document.documentElement.style.setProperty("--color-secondary", theme.easySignupPrincipalColor);
        }
        if (isHex(theme.easySignupPrincipalColor)) {
          document.documentElement.style.setProperty("--color-secondary", theme.easySignupPrincipalColor);
          setToggleSecondaryColor(theme.easySignupPrincipalColor);
        }
        if (isHex(theme.easySignupWelcomeColor)) {
          document.documentElement.style.setProperty("--color-msg-welcome", theme.easySignupWelcomeColor);
        }


        // Leggi allowCustomerSelfRegistration dalla risposta
        const allow = data.allowCustomerSelfRegistration === true 

        setRegistrationUrlDisabled(data.registrationUrlDisabled === true);
        setRegistrationUrlDeleted(data.registrationUrlDeleted === true);
        setRegistrationUrlDisabledBySource(data.registrationUrlDisabledBySource === true);

        setSelfRegistrationAllowed(allow);

        const couponWelcome = data.couponWelcome || {};
        setCouponEnabled(!!couponWelcome.enabled);
        setCouponMessageText(couponWelcome.descrizioneText || "");
        setCouponMessageHtml(couponWelcome.descrizioneHtml || "");

        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore:", err);
        setErrore(true);
        setSelfRegistrationAllowed(null);
        setRegistrationUrlDisabled(false);
        setRegistrationUrlDeleted(false);
        setRegistrationUrlDisabledBySource(false);
        setLoading(false);
      });
  }, [storeCodeEncrypted, source]);

  if (loading) 
  return <LoadingSpinner show={true} />;

  if (errore || !storeData)
    return (
      <div className="errore-caricamento-dati-farmacia">
        <h3>
          Errore: farmacia non trovata o codice farmacia non valido.
        </h3>
      </div>
    );

  function onSignupShowError(): void {
    setName({ ...name, showError: true });
    setSurname({ ...surname, showError: true });
    setNationalIdNumber({ ...nationalIdNumber, showError: true });
    setPhone({ ...phone, showError: true });
    setEmail({ ...email, showError: true });
  }

let pageContent = null;

if (registrationUrlDeleted || registrationUrlDisabledBySource) {
  pageContent = (
    <div className="show-final-success-page">
      <div>
        <i
          className="bi bi-exclamation-octagon-fill"
          style={{ color: "#d9534f", fontSize: "70px" }}
        ></i>
      </div>
      <div style={{ fontSize: 22, fontWeight: "bold" }}>
        Link non più disponibile
      </div>
      <p>
        Il link di registrazione utilizzato non è più valido perché è stato rimosso.
        Per maggiori informazioni rivolgiti direttamente alla farmacia.
      </p>
    </div>
  );
}
else if (registrationUrlDisabled) {
  pageContent = (
    <div className="show-final-success-page">
      <div>
        <i
          className="bi bi-pause-circle-fill"
          style={{ color: "#ed9c28", fontSize: "70px" }}
        ></i>
      </div>
      <div style={{ fontSize: 22, fontWeight: "bold" }}>
        Registrazione temporaneamente non disponibile
      </div>
      <p>
        Il link di registrazione è stato disabilitato temporaneamente.
        Per maggiori informazioni rivolgiti direttamente alla farmacia.
      </p>
    </div>
  );
}

else if (selfRegistrationAllowed === false) {
  pageContent = (
    <div className="show-final-success-page" >
      <div>
        <i className="bi bi-exclamation-triangle-fill" style={{"color":"#ed2b00ff", "fontSize":"70px"}} ></i>
        <div style={{"fontSize":"22px", "fontWeight":"bold"}}>Registrazione non disponibile</div>
        <p>
          La farmacia {storeData.name} non è abilitata alla registrazione semplificata
          dei clienti. Per maggiori informazioni rivolgiti direttamente alla farmacia.
        </p>
      </div>
    </div>
  );
} 
// Unifichiamo i controlli: entriamo qui se l'utente esiste (sia con utente app che senza)
if (showExistingCustomerPage || showExistingAppUserPage) {
  
  // CASO 0: MASSIMA SICUREZZA (MaxSecurity) - Blocco totale per chiunque
  if (securityBehaviour === SelfRegisterSecurityBehaviourEnum.MaxSecurity) {
    pageContent = (
      <div className="show-final-success-page">
        <i className="bi bi-shield-lock-fill" style={{ color: "#d9534f", fontSize: "70px" }}></i>
        <div style={{ fontSize: "24px", fontWeight: "bold" }}>Utente già registrato</div>      
        <p className="mt-3 text-center" style={{ maxWidth: "450px" }}>
          I suoi dati sono già presenti nei nostri sistemi. Per garantire la massima sicurezza e protezione dei suoi dati personali, 
          non è possibile visualizzare le informazioni o la card da questa pagina.
        </p>
        <p className="font-semibold text-center">
          La invitiamo a rivolgersi in farmacia per aggiornare i dati.
        </p>
      </div>
    );
  } 
  
  // CASI 1, 2, 3: PERMETTONO ALMENO LA VISUALIZZAZIONE DELLA CARD
  else {
    // Capiamo se l'utente ha già un account app controllando lo stato showExistingAppUserPage
    // oppure se avevi salvato una variabile booleana (es. const hasApp = !!username)
    const hasAppAccount = showExistingAppUserPage;

    pageContent = (
      <div className="show-final-success-page">
        <i className="bi bi-info-circle-fill" style={{ color: "var(--color-secondary)", fontSize: "70px" }}></i>
        <div style={{ fontSize: "24px", fontWeight: "bold" }}>Utente già registrato</div>      
        
        {/* Messaggio specifico se siamo in modalità aggiornamento dati mancanti (Caso 2) */}
        {securityBehaviour === SelfRegisterSecurityBehaviourEnum.ViewAnUpdateMissingData && (
          <div className="mt-2 text-green-600 font-medium">
            I dati mancanti inseriti sono stati aggiornati con successo.
          </div>
        )}
        
        {/* Messaggio specifico se siamo in modalità aggiornamento totale (Caso 3) */}
        {securityBehaviour === SelfRegisterSecurityBehaviourEnum.ViewAnUpdateAllData && (
          <div className="mt-2 text-green-600 font-medium">
            Profilo aggiornato correttamente con le nuove informazioni.
          </div>
        )}

        {/* Mostriamo l'email se siamo nei casi 1, 2 o 3, MA solo se la mail è stata effettivamente inviata */}
        {isMailSent && (
          <div className="mt-3 text-center text-gray-700" style={{ maxWidth: "450px" }}>
            <p>
              {securityBehaviour === SelfRegisterSecurityBehaviourEnum.ViewCardOnly 
                ? "Abbiamo inviato una email con i dettagli della tua Fidelity Card all'indirizzo:" 
                : "Ti abbiamo inviato un'email di conferma con i dettagli della tua Fidelity Card all'indirizzo:"}
            </p>
            <div className="mt-1 font-monospace p-2 bg-gray-100 rounded text-dark font-bold" style={{ letterSpacing: "1px" }}>
              {maskEmail(sentToEmail)}
            </div>
          </div>
        )}

        {/* Fallback di sicurezza: Livello 1 ma l'invio mail è fallito o l'indirizzo non c'era */}
        {securityBehaviour === SelfRegisterSecurityBehaviourEnum.ViewCardOnly && !isMailSent && (
          <div className="mt-2 text-amber-600 italic text-sm text-center" style={{ maxWidth: "450px" }}>
            Non è stato possibile inviare l'email di riepilogo. La invitiamo a recarsi in farmacia per aggiornare i dati.
          </div>
        )}

        {/* La card viene mostrata nei casi 1, 2 e 3 */}
        {generatedCard && (
          <div className="coupon-generated-box mt-4 p-3">
            <div style={{ fontSize: "20px", fontWeight: "bold" }}>
              La tua Fidelity Card
            </div>
            <div className="flex justify-content-center mt-3">
              <div className="flex flex-wrap align-items-center justify-content-center bg-white barcodeCardContainer">
                <img
                  className="barcodeCard"
                  src={textToBase64Barcode(fullCardCode)}
                  alt="Barcode card"
                />
                <div className="flex justify-content-center w-full mt-2">
                  <div className="flex align-items-center justify-content-center text-2xl barCodeNumber">
                    {fullCardCode}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* GESTIONE DEI BOTTONI IN BASE A SE HA GIÀ L'APP O NO */}
        {storeData?.appEnabled && (
          <div className="w-full flex flex-column align-items-center">
            {hasAppAccount ? (
              /* SOTTO-CASO A: L'utente HA GIÀ l'app -> Mostriamo SEMPRE il bottone Accedi (se consentito dai livelli 1,2,3) */
              <>
                <div className="mt-4 text-center" style={{ maxWidth: "400px" }}>
                  Utilizza le credenziali per accedere a MySalusApp.
                </div>
                <Button
                  style={{
                    backgroundColor: "var(--color-secondary)",
                    borderColor: "var(--color-secondary)",
                    color: "#fff",
                  }}
                  className="mt-4"
                  label="Accedi a MySalusApp"
                  onClick={() => goTo("/login")}
                />
              </>
            ) : (
              /* SOTTO-CASO B: L'utente NON ha l'app -> Il bottone di Registrazione compare nei Casi 2 e 3 */
              securityBehaviour === SelfRegisterSecurityBehaviourEnum.ViewAnUpdateAllData || 
              securityBehaviour === SelfRegisterSecurityBehaviourEnum.ViewAnUpdateMissingData ? (
                <>
                  <div className="mt-5 text-center" style={{ maxWidth: "400px" }}>
                    Registrati alla nostra app per avere sempre con te la tua Fidelity Card e scoprire tutti i vantaggi dedicati.
                  </div>
                  <Button
                    label="Registrati all'app"
                    onClick={() => setShowAppSignupDialog(true)}
                    className="mt-4"
                    style={{
                      backgroundColor: "var(--color-secondary)",
                      borderColor: "var(--color-secondary)",
                      color: "#fff",
                    }}
                  />
                </>
              ) : (
                /* Avviso per i casi 1 e 2 in cui non ha l'app e non può registrarsi da qui per sicurezza */
                <div className="mt-4 text-sm text-gray-500 italic" style={{ maxWidth: "400px", textAlign: "center" }}>
                  Per motivi di sicurezza, la creazione di un nuovo account MySalusApp non è disponibile tramite questa modalità.
                </div>
              )
            )}
          </div>
        )}
      </div>
    );
  }
}
else if (showFinalSuccessPage) {
  pageContent = (
    
    <div className="show-final-success-page">
      <i className="bi bi-hand-thumbs-up-fill" style={{ color: "var(--color-secondary)", fontSize: "70px" }}></i>
      <div style={{ fontSize: "24px", fontWeight: "bold" }}>Registrazione avvenuta correttamente</div>
      <div className="mt-2">Abbiamo inviato una email con i dettagli della sua Fidelity Card</div>

      {generatedCard && (
        <div className="coupon-generated-box mt-4 p-3">
          <div style={{ fontSize: "20px", fontWeight: "bold" }}>
            La tua Fidelity Card
          </div>

          <div className="flex justify-content-center mt-3">
            <div className="flex flex-wrap align-items-center justify-content-center bg-white barcodeCardContainer">
              <img
                className="barcodeCard"
                src={textToBase64Barcode(fullCardCode)}
                alt="Barcode card"
              />
              <div className="flex justify-content-center w-full mt-2">
                <div className="flex align-items-center justify-content-center text-2xl barCodeNumber">
                  {fullCardCode}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {generatedCoupon && (
        <Button
          label="Visualizza coupon di benvenuto"
          icon="pi pi-ticket"
          onClick={() => setShowCouponDialog(true)}
          className="mt-4"
          style={{
            backgroundColor: "var(--color-secondary)",
            borderColor: "var(--color-secondary)",
            color: "#fff",
          }}
        />
      )}


      {storeData?.appEnabled && (
        <>
          <div className="mt-5">
          Registrati alla nostra app per avere sempre con te la tua Fidelity Card e scoprire tutti i vantaggi dedicati.
          </div>
          <Button
            label="Registrati all'app"
            onClick={() => setShowAppSignupDialog(true)}
            className="mt-4"
            style={{
              backgroundColor: "var(--color-secondary)",
              borderColor: "var(--color-secondary)",
              color: "#fff",
            }}
          />
        </>
      )}
    </div>
  );
}
else {
  pageContent = (
    <>
      {/* qui lasci il form principale attuale */}
      <>
    {showMainScreen && (
    <div className="easy-signup-wrapper w-full h-full">
      <Toast ref={toast} />      
      
        <div className={storeData.logoAppImage ? "logoEasySignupHeader" : "header-easy-signup"}>
          <div className="logo-slot">
            {storeData.logoAppImage ? (
              <img
                className="logo-easy-signup-img"
                src={process.env.REACT_APP_STORAGE_URL + storeData?.logoAppImage?.replace("storage", "")}
                alt="Logo farmacia"
              />
            ) : (
              <h1 className="py-1 px-3 store-name m-0">{storeData.name}</h1>
            )}
          </div>
        </div>

        <div className="input-style-easy-signup form-container flex flex-column align-items-center  w-full">

          <div className="flex justify-content-center align-items-center">
            {/* 1) HTML ha priorità */}
            {storeData.couponWelcome?.descrizioneHtml && (
              <div
                className="px-2 text-black font-semibold coupon-style"                
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(storeData.couponWelcome.descrizioneHtml || "")
                }}
              />
            )}

            {/* 2) Solo testo se non c'è HTML */}
            {!storeData.couponWelcome?.descrizioneHtml && storeData.couponWelcome?.descrizioneText && (
              <div className="px-2 mt-4 text-black font-semibold coupon-style">
                {storeData.couponWelcome.descrizioneText}
              </div>
            )}

          </div>

          {/* nome */}
          <div
            className={`flex flex-column mb-4 ${
              couponEnabled ? "mt-5" : "mt-5"
            } signup-input-style`}
          >
            <span className="p-float-label ">
              <InputText
                maxLength={MAXLENGTH_NAME}
                value={name.value}
                onChange={(e) => {
                  const { info, validTotChars } = handleNameChange(
                    e.target.value,
                    surname.value
                  );
                  setName(info);
                  setCheckCharsNameSurname(validTotChars);
                }}
                onBlur={() => setName(handleNameBlur(name))}
              />

              <label htmlFor="Nome">Nome*</label>
            </span>

            {name.valid || !name.showError ? (
              ""
            ) : (
              <span>
                <small className="text-red-600">Campo obbligatorio</small>
              </span>
            )}
          </div>

          {/* cognome */}
          <div className="flex flex-column mb-4 mt-3 signup-input-style">
            <span className="p-float-label">
              <InputText
                maxLength={MAXLENGTH_SURNAME}
                value={surname.value}
                onChange={(e) => {
                  const { info, validTotChars } = handleSurnameChange(
                    e.target.value,
                    name.value
                  );
                  setSurname(info);
                  setCheckCharsNameSurname(validTotChars);
                }}
                onBlur={() => setSurname(handleSurnameBlur(surname))}
              />

              <label htmlFor="Cognome">Cognome*</label>
            </span>

            {surname.valid || !surname.showError ? (
              ""
            ) : (
              <span>
                <small className="text-red-600">Campo obbligatorio</small>
              </span>
            )}

            {!checkCharsNameSurname ? (
              <span>
                <small className="text-red-600">
                  La somma di caratteri del nome e del cognome non deve superare i
                  99 caratteri
                </small>
              </span>
            ) : (
              <></>
            )}
          </div>

          {/* codice fiscale */}
          <div className="flex flex-column mt-3 mb-4 signup-input-style">
            <span className="p-float-label p-input-icon-right">
              <div className="flex justify-content-between">
                <InputText
                  maxLength={MAXLENGTH_NATIONAL_ID_NUMBER}
                  value={nationalIdNumber.value}
                  onChange={(e) =>
                    setNationalIdNumber(
                      handleNationalIdChange(e.target.value, nationalIdNumber)
                    )
                  }
                  onBlur={() =>
                    setNationalIdNumber(handleNationalIdBlur(nationalIdNumber))
                  }
                />

                <label htmlFor="CodiceFiscale" style={{paddingLeft:"10px"}}>
                  Codice Fiscale*
                </label>
                <div
                  className="button-calcola-cf "
                  onClick={() => setShowCfDialog(true)}
                >
                  Calcola CF
                </div>
              </div>
            </span>

            {!nationalIdNumber.showError || nationalIdNumber.valid ? (
              ""
            ) : (
              <span>
                <small className="text-red-600">
                  {getErrorCodiceFiscale(nationalIdNumber)}
                </small>
              </span>
            )}
          </div>

          {/* email */}
          <div className="flex flex-column signup-input-style mb-4 mt-3">
            <span className="p-float-label">
              <InputText
                maxLength={MAXLENGTH_EMAIL}
                value={email.value}
                onChange={(e) =>
                  setEmail(handleEmailChange(e.target.value, email))
                }
                onBlur={() => setEmail(handleEmailBlur(email))}
              />

              <label htmlFor="Email">Email*</label>
            </span>

            {email.valid || !email.showError ? (
              ""
            ) : (
              <span>
                <small className="text-red-600"> {getErrorEmail(email)} </small>
              </span>
            )}
          </div>

          {/* cellulare */}
          <div className="flex flex-column signup-input-style mt-3">
            <span className="p-float-label">
              <InputText
                maxLength={MAXLENGTH_PHONE}
                value={phone.value}
                onChange={(e) =>
                  setPhone(handlePhoneChange(e.target.value, phone))
                }
                onBlur={() => setPhone(handlePhoneBlur(phone))}
              />

              <label htmlFor="Telefono">Cellulare*</label>
            </span>
            {phone.valid || !phone.showError ? (
              ""
            ) : (
              <span>
                <small className="text-red-600"> Formato non valido </small>
              </span>
            )}
          </div>
          <div className="consent-box px-4 mt-6">
            {/* <div className="consent-title">Gestione Consensi</div> */}

            <div className="consent-content gap-3 flex flex-column justify-content-center align-items-center">
              {/* Contenuto dei consensi */}
              <div className=" p-2 ">
                <div
                  className="text-sm my-4 px-2 flex justify-content-center align-items-center cursor-pointer "
                  onClick={() => setShowConsentDialog(true)}
                >
                  {/* <i className="pi pi-search text-xl mr-2 font-bold"></i> */}
                  <div className="flex flex-column justify-content-center align-items-end">
                    <div>
                      {/* Trattamento dei tuoi dati per finalità di fidelizzazione,
                      marketing e analisi nel rispetto della privacy. */}
                      {storeData.easySignupPrivacyIntroText}
                    </div>
                    <div className="button-visualizza-privacy">Informativa Privacy</div>
                  </div>
                </div>

                {/* <div className="mb-4 mx-1 text-sm">
                  Il/La sottoscritto/a dichiara inoltre di prestare il proprio
                  specifico consenso scritto al trattamento dei dati per le
                  ulteriori finalità di marketing e profilazione ed in
                  particolare:
                </div>

                <div className="text-sm mx-1 pr-2 flex">
                  <div className="single-privacy-box">
                    Lo svolgimento di attività di profilazione individuale o
                    aggregata e di ricerche di mercato volte, ad esempio,
                    all’analisi delle abitudini e delle scelte di consumo,
                    all’elaborazione di statistiche sulle stesse o alla
                    valutazione del grado di soddisfacimento dei prodotti e dei
                    servizi proposti.
                  </div>
                </div> */}
                <div className="text-sm mx-1 pr-2 flex">
                  <div className="single-privacy-box" style={{ whiteSpace: "pre-wrap" }}>
                    {storeData.easySignupPrivacyText1.length > 200 ? (
                      <>
                        {isPrivacy1Expanded
                          ? storeData.easySignupPrivacyText1
                          : `${storeData.easySignupPrivacyText1.substring(0, 200)}...`
                        }
                        <span
                          onClick={() => setIsPrivacy1Expanded(!isPrivacy1Expanded)}
                          className="text-primary font-bold cursor-pointer ml-1 select-none"
                          style={{ textDecoration: 'underline', color: 'var(--color-secondary)' }}
                        >
                          {isPrivacy1Expanded ? ' Mostra meno' : ' Mostra tutto'}
                        </span>
                      </>
                    ) : (
                      storeData.easySignupPrivacyText1
                    )}
                  </div>
                </div>
                <div className="flex justify-content-end align-items-center mr-2 mb-4 mt-3">
                  <div className="flex flex-column">
                    <label className="mr-2">Acconsento</label>
                    {/* {showErrorConsentProfilazione && !consentProfilazione && (
                      <small className="text-red-600 ml-2">Obbligatorio</small>
                    )} */}
                  </div>
                      <InputSwitch
                        checked={consentProfilazione}
                        onChange={(e) => setConsentProfilazione(e.value)}
                      />
                </div>

                {/* <div className="text-sm mx-1 pr-2 flex">
                  <div className="single-privacy-box">
                    Lo svolgimento di attività di marketing diretto, quali l’invio
                    - anche tramite e-mail, SMS, MMS e APP - di materiale
                    pubblicitario e di comunicazioni aventi contenuto informativo
                    e/o promozionale in relazione a prodotti o servizi forniti e/o
                    promossi dal Titolare o dai Responsabili Esterni quali
                    Fidelity Salus Service & Consulting srl, ivi compresi omaggi e
                    campioni gratuiti
                  </div>
                </div> */}
                <div className="text-sm mx-1 pr-2 flex">
                  <div className="single-privacy-box" style={{ whiteSpace: "pre-wrap" }}>
                    {storeData.easySignupPrivacyText2.length > 200 ? (
                      <>
                        {isPrivacy2Expanded
                          ? storeData.easySignupPrivacyText2
                          : `${storeData.easySignupPrivacyText2.substring(0, 200)}...`
                        }
                        <span
                          onClick={() => setIsPrivacy2Expanded(!isPrivacy2Expanded)}
                          className="text-primary font-bold cursor-pointer ml-1 select-none"
                          style={{ textDecoration: 'underline', color: 'var(--color-secondary)' }}
                        >
                          {isPrivacy2Expanded ? ' Mostra meno' : ' Mostra tutto'}
                        </span>
                      </>
                    ) : (
                      storeData.easySignupPrivacyText2
                    )}
                  </div>
                </div>
                <div className="flex justify-content-end align-items-center mr-2 mb-4 mt-3">
                  <div className="flex flex-column">
                    <label className="mr-2">Acconsento</label>
                    {/* {showErrorConsentMarketing && !consentMarketing && (
                      <small className="text-red-600 ml-2">Obbligatorio</small>
                    )} */}
                  </div>
                    <InputSwitch
                      checked={consentMarketing}
                      onChange={(e) => setConsentMarketing(e.value)}
                    />
                </div>

                {storeData.privacy3Enabled.value === true ? (
                  <>
                    <div className="text-sm mx-1 pr-2 flex flex-column"> {/* Aggiunto flex-column per far andare il bottone sotto se serve */}
                      <div className="single-privacy-box">
                        {/* Gestione del testo troncato */}
                        {storeData.privacy3Enabled.name.length > 200 ? (
                          <>
                            {isPrivacy3Expanded 
                              ? storeData.privacy3Enabled.name 
                              : `${storeData.privacy3Enabled.name.substring(0, 200)}...`
                            }
                            <span 
                              onClick={() => setIsPrivacy3Expanded(!isPrivacy3Expanded)}
                              className="text-primary font-bold cursor-pointer ml-1 select-none"
                              style={{ textDecoration: 'underline', color: 'var(--color-secondary)' }}
                            >
                              {isPrivacy3Expanded ? ' Mostra meno' : ' Mostra tutto'}
                            </span>
                          </>
                        ) : (
                          // Se è più corto di 200 caratteri lo mostra normalmente senza pulsanti
                          storeData.privacy3Enabled.name
                        )}
                      </div>
                    </div>
                    
                    <div className="flex justify-content-end align-items-center mr-2 mb-3 mt-2">
                      <div className="flex flex-column">
                        <label className="mr-2">Acconsento</label>
                      </div>
                        <InputSwitch
                          checked={privacy3}
                          onChange={(e) => setPrivacy3(e.value)}
                        />
                    </div>
                  </>
                ) : (
                  <div></div>
                )}
              </div>
            </div>
          </div>
        <Dialog
          header="Privacy"
          visible={showConsentDialog}
          onHide={() => setShowConsentDialog(false)}
          style={{ width: "90vw", maxWidth: "500px" }}
          draggable={false}
          resizable={false}
        >
          <div className="text-area-privacy mb-3" style={{ whiteSpace: "pre-wrap" }}>
            {storeData.easySignupPrivacyViewText}
          </div>
          {/* <div>
            <div className="text-area-privacy mb-3">
              <strong>MODALITA' DEL TRATTAMENTO</strong>
              <br />
              Il trattamento dei dati avverrà con l’ausilio di strumenti
              elettronici e/o cartacei, secondo logiche strettamente correlate
              alle finalità sopra indicate e comunque adottando procedure e
              misure idonee a tutelarne la sicurezza e la riservatezza. <br />
              <br />
              <strong>FINALITA' DEL TRATTAMENTO</strong>
              <br />
              Il trattamento dei dati sarà finalizzato allo svolgimento delle
              attività di seguito elencate:
              <br />
              a) rilascio della Carta Fedeltà e gestione delle attività non
              esercitabili in forma anonima e necessarie per consentire ai
              sottoscrittori la fruizione e il riconoscimento degli sconti e
              delle promozioni, l’offerta e l’invio di premi, la partecipazione
              a raccolte punti e l’accesso agli altri servizi accessori
              utilizzabili mediante la Carta;
              <br />
              b) svolgimento, previo Suo espresso consenso scritto, di attività
              di marketing diretto, quali l’invio - anche tramite e-mail, SMS,
              MMS ed APP - di materiale pubblicitario e di comunicazioni aventi
              contenuto informativo e/o promozionale in relazione a prodotti o
              servizi forniti e/o promossi dal Titolare o, per conto del
              Titolare, forniti/promossi dal Responsabile Esterno Fidelity Salus
              Service & Consulting srl, ivi compresi omaggi e campioni gratuiti;
              <br />
              c) svolgimento, previo Suo espresso consenso scritto, di attività
              di profilazione individuale o aggregata e di ricerche di mercato
              volte, ad esempio, all’analisi delle abitudini e delle scelte di
              consumo, all’elaborazione di statistiche sulle stesse o alla
              valutazione del grado di soddisfacimento rispetto ai prodotti ed
              ai servizi proposti. I dati trattati per finalità di profilazione
              o marketing possono essere conservati per un periodo non superiore
              ai 36 mesi dall’ultima transazione effettuata, salva la loro reale
              trasformazione in forma anonima che non permetta anche
              indirettamente di identificare gli interessati. Nel caso di
              eventuale ritiro, disabilitazione per mancato utilizzo entro un
              determinato arco temporale, scadenza o restituzione della carta,
              deve essere individuato un termine di conservazione dei dati
              personali per esclusive finalità amministrative (e non anche di
              profilazione e marketing) non superiore ad un trimestre.
              <br />
              <br />
              <strong>CONSENSO AL TRATTAMENTO DEI DATI PERSONALI</strong>
              <br />
              Letta la presente informativa, il/la sottoscritto/a dichiara di
              averne compreso il contenuto. Le facciamo presente che la
              manifestazione del Suo consenso espresso all’effettuazione del
              trattamento dei Suoi dati personali, da parte del Titolare.,
              finalizzato al rilascio della Carta Fedeltà ed alla gestione delle
              attività non esercitabili in forma anonima e necessarie per
              consentire ai sottoscrittori la fruizione e il riconoscimento
              degli sconti e delle promozioni, l’offerta e l’invio di premi, la
              partecipazione a Raccolte Punti e l’accesso agli altri servizi
              accessori utilizzabili mediante la Carta, è superflua. Il
              trattamento dei dati preordinato alla fidelizzazione in senso
              stretto è necessario per eseguire obblighi derivanti da un
              contratto del quale è parte l’interessato (art.6,7,8,9 Regolamento
              Privacy UE 2016/679)
            </div>
          </div> */}
        </Dialog>
        <Dialog
          header="Calcola il codice fiscale"
          visible={showCfDialog}
          onHide={() => setShowCfDialog(false)}
          style={{ width: "90vw", maxWidth: "500px" }}
        >
          <CodiceFiscaleCalculator
            initialNome={name.value}        // nome dal form principale
            initialCognome={surname.value}  // cognome dal form principale
            calcData={cfCalcData}
            onCalcDataChange={setCfCalcData}
            onCodiceFiscaleCalcolato={(cf) => {
              // setNationalIdNumber({ value: cf, valid: true, showError: true });
              setNationalIdNumber((prev) => ({
                ...prev,
                value: cf,
                valid: true,
                showError: false,
              }));
              setShowCfDialog(false); // opzionale: chiude il dialog dopo l’inserimento
            }}
          />
        </Dialog>
        <Dialog
          header="Informativa Privacy"
          visible={showPrivacyDialog}
          onHide={() => setShowPrivacyDialog(false)}
          style={{ width: "95%", maxWidth: "500px" }}
          modal
          dismissableMask
          blockScroll
          draggable={false}
        >
          {errorViewerFilePdf.current ? (
            renderErrorViewerPdf()
          ) : (
            <>
              <Worker
                key={renderKeyWorker}
                workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js"
              >
                <Viewer
                  fileUrl={`${window.location.origin}/Informativa_privacy.pdf`}
                  defaultScale={SpecialZoomLevel.PageWidth}
                  viewMode={ViewMode.SinglePage}
                  renderLoader={() => <LoadingSpinner show={true} />}
                  renderError={(error: LoadError) => {
                    errorViewerFilePdf.current = true;
                    return renderErrorViewerPdf();
                  }}
                  onDocumentLoad={() => {
                    errorViewerFilePdf.current = false;
                  }}
                />
              </Worker>
            </>
          )}
        </Dialog>
        
        <Dialog
            header="Registrazione all'app completata"
            visible={showAppSuccessDialog}
            onHide={() => setShowAppSuccessDialog(false)}
            style={{ width: "80vw", maxWidth: "400px" }}
            modal
            >
            <p>La registrazione all'app è avvenuta con successo!</p>
            <div className="flex justify-content-end gap-2 mt-4">
                <Button
                label="Ok"
                onClick={async () => {
                    setShowAppSuccessDialog(false);
                    await getUser(usernameApp, passwordApp);
                }}
                />
            </div>
        </Dialog>

        <Button
          onClick={handleSignup}
          label={loadingRegister ? "Registrazione..." : "Registrati"}
          disabled={loadingRegister || registrationSuccess}
          loading={loadingRegister}
          style={{ borderRadius: "24px" }}
          className="w-20rem mx-auto m-4 p-3 button-registrati "
        ></Button>
      </div>

      <div className="footer-login-easy-signup flex flex-column align-items-end justify-content-center ">
        <div className="font-footer flex-column flex align-items-center justify-content-center w-full ">
          <div className="store-address flex-column flex align-items-center justify-content-center ">
            <div className="flex flex align-items-start justify-content-start">
              {/* <i className="pi pi-map-marker mr-1 " style={{ color: 'white' }} ></i> */}
              <small className="">{storeData.address.address}</small>
              <small className="mx-2">{storeData.address.zipCode}</small>
              <small>{storeData.address.city}</small>
            </div>
            <div className="flex flex-column align-items-center justify-content-between  ">
              <div>
                {/* <i className="pi pi-envelope mr-1" style={{ color: 'white' }} ></i> */}
                <small>Email: </small>
                <small>{storeData.email}</small>
              </div>
              <div>
                {/* <i className="pi pi-phone mr-1 mt-2" style={{ color: 'white' }}></i> */}
                <small>Telefono: </small>
                <small>{storeData.telephone}</small>
              </div>
            </div>
          </div>
          {/* <div className="flex mt-3">
            <small>Fidelity Salus Service & Consulting Srl</small>
            <small>Partita IVA IT02999210541</small>
          </div> */}
        </div>
        <div
          className="mr-2"
          style={{ fontSize: "11px" }}
          onClick={() => {
            setShowPrivacyDialog(true);
          }}
        >
          Termini di utilizzo
        </div>
      </div>
    </div>
    )}

    </>
    </>
  );
}

return (
  <>
    <Toast ref={toast} />

    {pageContent}

    <Dialog
          header="Coupon di benvenuto"
          visible={showCouponDialog}
          onHide={() => setShowCouponDialog(false)}
          style={{ width: "90vw", maxWidth: "520px" }}
          modal
          draggable={false}
          resizable={false}
        >
          {generatedCoupon && (
            <div className="coupon-generated-box p-3">

              {generatedCoupon?.offerTitle && (
                <div
                  className="mt-3 p-3"
                  style={{
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px", color: "#444", marginBottom: "6px", fontWeight: 600 }}>
                    {generatedCoupon.offerTitle}
                  </div>

                  {!!generatedCoupon.offerValue && (
                    <div style={{ fontSize: "30px", fontWeight: "bold", color: "#145295" }}>
                      {generatedCoupon.offerValue}
                    </div>
                  )}
                </div>
              )}

              <div className="mt-2">{generatedCoupon.description}</div>

              <div className="flex justify-content-center mt-3">
                <div className="flex flex-wrap align-items-center justify-content-center bg-white barcodeCardContainer">
                  <img
                    className="barcodeCard"
                    src={textToBase64Barcode(generatedCoupon.couponCode)}
                    alt="Barcode coupon"
                  />
                  <div className="flex justify-content-center w-full mt-2">
                    <div className="flex align-items-center justify-content-center text-2xl barCodeNumber">
                      {generatedCoupon.couponCode}
                    </div>
                  </div>
                </div>
              </div>

              {(generatedCoupon.redemptionFrom || generatedCoupon.redemptionTo) && (
                <div className="mt-3">
                  Valido{" "}
                  {generatedCoupon.redemptionFrom && (
                    <>
                      dal <span className="coupon-validity-date">{formatCouponDate(generatedCoupon.redemptionFrom)}</span>
                    </>
                  )}
                  {generatedCoupon.redemptionTo && (
                    <>
                      {" "}al <span className="coupon-validity-date">{formatCouponDate(generatedCoupon.redemptionTo)}</span>
                    </>
                  )}
                </div>
              )}




              <div className="mt-2">
                {generatedCoupon.isValidForAllStores
                  ? "Utilizzabile presso tutti i nostri punti vendita."
                  : "Utilizzabile nel punto vendita di registrazione."}
              </div>
            </div>
          )}
        </Dialog>

    <Dialog
      header="Registrazione MySalusApp"
      visible={showAppSignupDialog}
      onHide={() => setShowAppSignupDialog(false)}
      style={{ width: "90vw", maxWidth: "500px" }}
      modal
      closable={false}
    >
      <div className="p-fluid">
        <div className="field mb-3">
          <label htmlFor="usernameApp">Scegli Username</label>
          <InputText
            id="usernameApp"
            value={usernameApp}
            onChange={(e) => {
              setUsernameApp(e.target.value);
              if (showUsernameError) setShowUsernameError(false);
              if (usernameAppError) setUsernameAppError('');
            }}
            onBlur={() => setShowUsernameError(true)}
          />
          {usernameAppError ? (
              <small className="text-red-600">{usernameAppError}</small>
          ) : showUsernameError && !isUsernameValid && usernameApp.length < 3 ? (
              <small className="text-red-600">
                  Lo username deve contenere almeno 3 caratteri.
              </small>
          ) : null}
        </div>

        <div className="field my-4">
          <label htmlFor="passwordApp">Scegli Password</label>
          <span className="p-input-icon-right w-full password-eye-wrapper">
            <InputText
              id="passwordApp"
              type={showPasswordApp ? "text" : "password"}
              value={passwordApp}
              onChange={(e) => setPasswordApp(e.target.value)}
              className="w-full"
            />
            <i
              className={`pi ${showPasswordApp ? "pi-eye-slash" : "pi-eye"} easy-signup-password-eye-icon`}
              onClick={() => setShowPasswordApp((prev) => !prev)}
            />
          </span>


            <div className="mt-2">
              {passwordChecks.map((item) => (
                <small
                  key={item.label}
                  className="block"
                  style={{ color: item.valid ? "#16a34a" : "#9ca3af" }}
                >
                  {item.valid ? "✓" : "•"} {item.label}
                </small>
              ))}
            </div>

        </div>

        <div className="flex justify-content-between">
          <Button
            label="Annulla"
            className="m-2"
            onClick={() => setShowAppSignupDialog(false)}
          />
          <Button
            label="Registrati"
            className="m-2"
            disabled={!isUsernameValid || usernameApp.length < 3 || !isPasswordValidDetailed}
            onClick={async () => {
              const isUsernameValid = checkValidationRequiredString(
                usernameApp,
                Enum_ValidationString.Username
              );

              if (
                !isUsernameValid ||
                usernameApp.length < 3 ||
                !isPasswordValidDetailed ||
                !selfRegisterRequest
              ) {
                toast.current?.show({
                  severity: "warn",
                  summary: "Campi non validi",
                  detail: "Username o password non validi.",
                });
                return;
              }

              setLoadingRegister(true);

              const request: RegisterUserAndCustomerRequestModel = {
                ...selfRegisterRequest,
                SignInName: usernameApp,
                Password: passwordApp,
              };

              console.log("APP REGISTER REQUEST", request);

              const result = await registerUserAndCustomer(request);

              if (result.type === 'success') {
                  setUsernameAppError('');
                  setShowAppSignupDialog(false);
                  clearLocalStorage();
                  sessionStorage.clear();
                  await getUser(usernameApp, passwordApp);
              } else {
                  const backendMessage = result?.message ?? '';

                  if (
                      backendMessage.toLowerCase().includes('username') &&
                      (
                          backendMessage.toLowerCase().includes('già in uso') ||
                          backendMessage.toLowerCase().includes('gia in uso') ||
                          backendMessage.toLowerCase().includes('already exists') ||
                          backendMessage.toLowerCase().includes('already in use')
                      )
                  ) {
                      setUsernameAppError(backendMessage);
                  } else {
                      toast.current?.show({
                          severity: 'error',
                          summary: 'Registrazione app non riuscita',
                          detail: backendMessage,
                          life: 5000,
                      });
                  }
              }

              setLoadingRegister(false);
            }}
          />
        </div>
      </div>
    </Dialog>
  </>  
);



}
